export default "__VITE_ASSET__Rt4cRtoo__"